module.exports = {
          srcSet: __webpack_public_path__ + "0dddf3e11d38301654a3dc2042bff6ba-167.png"+" 167w",
          images:[ {path: __webpack_public_path__ + "0dddf3e11d38301654a3dc2042bff6ba-167.png",width: 167,height: 172}],
          src: __webpack_public_path__ + "0dddf3e11d38301654a3dc2042bff6ba-167.png",
          toString:function(){return __webpack_public_path__ + "0dddf3e11d38301654a3dc2042bff6ba-167.png"},
          
          width: 167,
          height: 172
        }